import React, { Component } from "react";
import { connect } from "react-redux";

import ProjectVariationNumberForm from "./form";
import { createProjectVariationNumber } from "../actions";
import { Form } from "react-final-form";

import SlidingPane from "modules/5_view_helpers/web/SlidingPane";

function mapStateToProps(state) {
  return {};
}

class NewProjectVariationSliding extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    this.state = {
      isOpen: this.props.isOpen,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const prevIsOpen = prevState.isOpen;
    const { isOpen } = this.props;

    if (prevIsOpen != isOpen) {
      this.setState({ isOpen: isOpen });
    }
  }

  submitForm(values) {
    const { project_id } = this.props;
    const createRequest = this.props.createProjectVariationNumber(project_id, values);
    createRequest.then(() => this.successfullySubmitted(values));
  }

  successfullySubmitted(values) {
    const { toggle, afterCreated } = this.props;
    toggle();
    if (afterCreated) afterCreated(values);
    toastr.success("Created New Project Variaton Number");
  }

  render() {
    const { isOpen } = this.state;
    const { toggle } = this.props;

    return (
      <SlidingPane isOpen={isOpen} onRequestClose={toggle} title="New Project Variation" width="50%">
        <Form component={ProjectVariationNumberForm} formLabel="Create" onSubmit={this.submitForm} cancelFunction={toggle} {...this.props} />
      </SlidingPane>
    );
  }
}

export default connect(mapStateToProps, { createProjectVariationNumber })(NewProjectVariationSliding);
